namespace TabAurous.Finance {
    export interface OpeningBalanceRow {
        TransId?: number;
        TransDate?: string;
        VoucherNo?: string;
        VoucherTypeId?: number;
        PartyId?: number;
        LedgerName?: string;
        OpeningBalanceTypeId?: Common.OpeningBalanceType;
        CurrencyId?: number;
        ExchRate?: number;
        Amount?: number;
        CCAmount?: number;
        Remark?: string;
        CompanyId?: number;
        FinancialYearId?: number;
        UserId?: number;
        IsPosted?: boolean;
        PostingDate?: string;
        AutoPosting?: boolean;
    }

    export namespace OpeningBalanceRow {
        export const idProperty = 'TransId';
        export const nameProperty = 'VoucherNo';
        export const localTextPrefix = 'Finance.OpeningBalance';
        export const deletePermission = 'Finance:OpeningBalance:Delete';
        export const insertPermission = 'Finance:OpeningBalance:Add';
        export const readPermission = '*';
        export const updatePermission = 'Finance:OpeningBalance:Edit';

        export declare const enum Fields {
            TransId = "TransId",
            TransDate = "TransDate",
            VoucherNo = "VoucherNo",
            VoucherTypeId = "VoucherTypeId",
            PartyId = "PartyId",
            LedgerName = "LedgerName",
            OpeningBalanceTypeId = "OpeningBalanceTypeId",
            CurrencyId = "CurrencyId",
            ExchRate = "ExchRate",
            Amount = "Amount",
            CCAmount = "CCAmount",
            Remark = "Remark",
            CompanyId = "CompanyId",
            FinancialYearId = "FinancialYearId",
            UserId = "UserId",
            IsPosted = "IsPosted",
            PostingDate = "PostingDate",
            AutoPosting = "AutoPosting"
        }
    }
}
